module.exports = __webpack_public_path__ + "img/Slide13.c60d0cf4.png";